import { createSlice, PayloadAction } from '@reduxjs/toolkit'

interface GooglePlacesState {
  isLoading: boolean
  error: string | null
}

const initialState: GooglePlacesState = {
  isLoading: true,
  error: null,
}

const googlePlacesSlice = createSlice({
  name: 'googlePlaces',
  initialState,
  reducers: {
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.isLoading = action.payload
    },
    setError: (state, action: PayloadAction<string | null>) => {
      state.error = action.payload
    },
    resetState: () => initialState,
  },
})

export const { setLoading, setError, resetState } = googlePlacesSlice.actions
export default googlePlacesSlice.reducer
